import { getClientInfoFromCookie } from '@commenda/auth';
import { isCommendaInternalEmail } from '@commenda/utils';

import { IndirectTaxFilingAccessHelper } from '../helpers/IndirectTaxFilingAccessHelper';
import { IndirectTaxRegion } from '../types';

export const useIndirectTaxFilingAccess = (region: IndirectTaxRegion) => {
  const isInternalUser = isCommendaInternalEmail(
    getClientInfoFromCookie()?.user?.email
  );
  return {
    isInternalUser,
    canViewDetails: IndirectTaxFilingAccessHelper.canViewDetails(
      region,
      isInternalUser
    ),
    isCalendarOnly: IndirectTaxFilingAccessHelper.isCalendarOnly(
      region,
      isInternalUser
    ),
  };
};
